export default "Viniyoga-spezifische Pilotstudie bei Brustkrebsüberlebenden – mit manualisiertem Programm und explizitem Praxisziel regelmäßiger Heimübung."